<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="dialogTitle" width="800" draggable>
            <div class="userAdd_man">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('field.deviceName')">{{ rowInfo.title }}</el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('field.deviceCode')">{{ rowInfo.code }}</el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('field.model')">{{ rowInfo.model }}</el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenanceAudit.partName')">{{ rowInfo.name }}</el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenanceAudit.maintenanceContent')">{{ rowInfo.content }}</el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenanceAudit.scheduleDate')">
                            {{ rowInfo.schedule_date ? rowInfo.schedule_date.split(' ')[0] : '-' }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenanceAudit.assignee')">{{ rowInfo.real_name }}</el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="t('maintenanceAudit.materials')">
                            <hc-oss-image-list :value="rowInfo.material_url" />
                        </el-form-item>
                    </el-col>
                    <el-divider></el-divider>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenanceAudit.submitInfo')">{{ rowInfo.remark }}</el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('maintenanceAudit.auditStatus')">
                            <el-switch v-model="state.form.status" :active-value="2" :inactive-value="4"
                                :active-text="t('maintenanceAudit.pass')" :inactive-text="t('maintenanceAudit.reject')" />
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="submit">{{ t('common.confirm') }}</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { reactive, ref, defineEmits, defineProps, defineExpose, computed } from "vue";
import { ElMessage } from "element-plus";
import { auditApi } from "@/api/maintenance/maintenance.js";
import { usePageI18n, t } from "@/composables/usePageI18n.js";

const emit = defineEmits(['refresh']);
const props = defineProps({
    title: { type: String, default: '' },
});

const dialogTitle = computed(() => props.title || t('maintenanceAudit.title'));
const rules = reactive({});
const state = reactive({ dialogVisible: false, form: { id: 0, status: 4 } });
const rowInfo = ref(null);

const getImgArr = (str) => {
    if (!str) return [];
    try {
        return JSON.parse(str).map(i => i.url);
    } catch {
        return [];
    }
};

const open = (row) => {
    state.dialogVisible = true;
    rowInfo.value = row;
};

const ruleForm = ref(null);
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (!valid) return false;
        auditApi(JSON.stringify({ id: rowInfo.value.id, status: state.form.status })).then(res => {
            if (res?.code === 200) {
                ElMessage.success(t('common.success'));
                state.dialogVisible = false;
                state.form = { id: 0, status: 4 };
                emit('refresh');
            }
        });
    });
};

usePageI18n(() => {});
defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}
.userFrom {
    display: flex;
    flex-wrap: wrap;
}
.record-img {
    width: 160px;
    height: 160px;
    border-radius: 6px;
    object-fit: cover;
    margin-left: 10px;
}
</style>
